<template>
  <v-flex :class="classObj" :title='component.label'>
    <v-label v-if="component.label" class="uf-label"> {{ component.label }} </v-label>
    <a :href="component.link" target="_blank" >
      <img :src="require(`@/assets/${component.url}`)" :style="imageStyle">
    </a>
  </v-flex>
</template>

<script>
export default {
  name: 'u-image',

  props: {
    id: {
      type: String
    },
    component: {
      type: Object
    },
    resultForm: {
      type: Object
    }
  },

  computed: {
    imageStyle () {
      return this.component.imageStyle || 'height: 100%; width: 100%;'
    }
  }
}
</script>

<style lang='stylus' scoped>
  div label
    font-size 12px
</style>



// WEBPACK FOOTER //
// src/components/form/inputs/Image.vue